import { useTranslation } from "react-i18next";
import NAV_TABS from "./navConfig";

export default function StudentMobileNav({ activeTab, setActiveTab }) {
  const { t } = useTranslation();

  return (
    <div className="md:hidden border-b border-slate-200 bg-white">
      <div className="flex overflow-x-auto scrollbar-hide">
        {NAV_TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex-shrink-0 flex flex-col items-center gap-1 px-3 py-2.5 text-[10px] font-medium transition-colors whitespace-nowrap ${
              activeTab === tab.id
                ? "text-sky-600 border-b-2 border-sky-500 bg-sky-50"
                : "text-slate-500"
            }`}
            data-testid={`mobile-tab-${t(tab.labelKey).toLowerCase()}`}
          >
            <tab.icon className="w-4 h-4" />
            {t(tab.labelKey)}
          </button>
        ))}
      </div>
    </div>
  );
}
